
import { createClient } from '@supabase/supabase-js';
import { Database } from './types';

const supabaseUrl = 'https://mjatochkqafjodfnlbky.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1qYXRvY2hrcWFmam9kZm5sYmt5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzY3OTQ3ODMsImV4cCI6MjA1MjM3MDc4M30.aMT_sNgE7etCnHW6hHbxpDWmE2KeOifRWFGbyGCSuAo';

export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storage: window.localStorage,
    flowType: 'implicit',
  }
});
